// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // serverUrl: 'http://34.demodxcs.com/v1',
  // kibanaUrl: 'http://34.demodxcs.com/kibana/',
  serverUrl: 'https://remotepass.dx-compliance.com/v1',
  kibanaUrl: 'https://remotepass.dx-compliance.com/kibana/',
  neo4jUrl: 'bolt://54.217.61.56:7687',
  neo4jUserName: 'neo4j',
  neo4jPassword: 'i-0ae0f4f2045ee3d9b',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
